export default __webpack_public_path__ + "static/media/pending_mature.75cea3a1.jpg";